import React from 'react';

import { NewsletterSubscription } from '@/utils/functions/subscribe-to-newsletter';

interface ISVGCheckboxProps {
    isChecked: boolean;
    onChecked: (subscriptionKey: NewsletterSubscription) => void;
    subscriptionKey: NewsletterSubscription;
}

const SVGCheckbox = ({ isChecked, onChecked, subscriptionKey }: ISVGCheckboxProps) => (
    <div
        className="flex w-[25px] relative gap-2.5"
        onClick={() => onChecked(subscriptionKey)}
        onKeyDown={() => onChecked(subscriptionKey)}
        tabIndex={0}
        role="checkbox"
        aria-checked={isChecked}
    >
        <svg
            width="26"
            height="25"
            viewBox="0 0 26 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[25px] h-[25px]"
            preserveAspectRatio="none"
        >
            <rect x="0.869141" y="9.5" width="15" height="15" stroke="#B4B4B4" strokeOpacity="0.35"></rect>
            {isChecked && (
                <path
                    d="M9.52995 16.5365L5.1862 12.1927L3.70703 13.6615L9.52995 19.4844L22.0299 6.98437L20.5612 5.51562L9.52995 16.5365Z"
                    fill="#5637CD"
                ></path>
            )}
        </svg>
    </div>
);

export default SVGCheckbox;
